import { Button } from '@atgfr8/atg-ui-tailwind';
import { closeModal } from '@store/modals/store';
import { For } from 'solid-js';

import { loadSureEligibilityModal } from './LoadSureHelpers';

type LoadSureEligibilityModalProps = {
  failures: string[];
};

export const LoadSureEligibilityModal = (
  props: Readonly<LoadSureEligibilityModalProps>,
) => (
  <div
    class="flex flex-col overflow-hidden rounded-[5px]"
    data-testid="loadsure-eligibility-modal"
  >
    <div class="bg-[#F9FAFC] border-b border-[#ECECEE] px-6 py-3">
      <div class="text-lg font-semibold text-[#2B2B2B]">
        Eligibility Requirements Not Met
      </div>
    </div>
    <div class="px-6 py-5">
      <div class="text-sm text-[#2B2B2B]">
        The selected carrier does not meet the following requirements to
        purchase coverage for this load:
      </div>
      <div class="mt-5 bg-[#FBE9E7] border border-[#E2C9CD] rounded-lg px-4 py-5">
        <ul class="list-disc pl-5 space-y-2 text-sm text-[#8D001A]">
          <For each={props.failures}>{(failure) => <li>{failure}</li>}</For>
        </ul>
      </div>
    </div>
    <div class="bg-[#F9FAFC] border-t border-[#ECECEE] px-6 py-3 flex justify-end">
      <Button
        type="button"
        onClick={() => closeModal(loadSureEligibilityModal)}
        dataTestId="loadsure-eligibility-close-button"
      >
        CLOSE
      </Button>
    </div>
  </div>
);
